import React, { Fragment } from 'react';
import Report from '../../../../Reports';

const ReportComponent = (props) => {
  let { graphprops, AssetCode } = props;
  return (
    <Fragment>
      <Report
        match={{
          params: {
            report: graphprops && graphprops[graphprops.graph] && graphprops[graphprops.graph].ReportName
              ? graphprops[graphprops.graph].ReportName
              : '',
            reportType: 'Report'
          }
        }}
        location={{
          search: `?AssetCode=${AssetCode}&report=true`
        }}
      />
    </Fragment>
  );
};

export default ReportComponent;